export const UA_TOOLTIP_CLASS = 'ua-tooltip';
export const UA_TOOLTIP_DATA_ATTRIBUTE = 'data-ua-tooltip';
